import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const arrow2Style = {
  content: '""',
  position: "absolute",
  top: "50%",
  left: "",
  transform: "translateY(-50%)",
  width: 0,
  height: 0,
  borderTop: {
    xs: "20px solid transparent",
    sm: "20px solid transparent",
    md: "25px solid transparent",
  },
  borderBottom: {
    xs: "20px solid transparent",
    sm: "20px solid transparent",
    md: "25px solid transparent",
  },
  borderLeft: {
    xs: "15px solid white",
    sm: "15px solid white",
    md: "20px solid white",
  },
};

function BreadCrumb({ text, to, isLast }) {
  return (
    <Box
      sx={{
        minWidth: { xs: "30px", sm: "30px", md: "80px" },
        height: { xs: "35px", sm: "35px", md: "40px" },
        position: "relative",
        display: "inline-block",
        mr: { xs: "45px", sm: "45px", md: "20px" },
        mb: 1,
        cursor: isLast ? "default" : "pointer",
      }}
    >
      <Box sx={arrow2Style} />
      <Box
        sx={{
          minWidth: { xs: "30px", sm: "30px", md: "80px" },
          height: "100%",
          background: "#27B1BB",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 3, sm: 3, md: 3 },
        }}
      >
        {isLast ? (
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "16px", md: "18px" },
              fontFamily: "Poppins",
              fontWeight: { xs: 300, sm: 400, md: 500 },
              color: "#ffffff",
              ml: { xs: 2, sm: 2, md: 2 },
            }}
            aria-current="page"
          >
            {text}
          </Typography>
        ) : (
          <Typography
            component={Link}
            to={to}
            sx={{
              fontSize: { xs: "16px", sm: "16px", md: "18px" },
              fontFamily: "Poppins",
              fontWeight: { xs: 300, sm: 400, md: 500 },
              color: "#ffffff",
              ml: { xs: 2, sm: 2, md: 2 },
              textDecoration: "none",
            }}
          >
            {text}
          </Typography>
        )}
      </Box>
      {/* {!isLast && ( */}
      <Box
        sx={{
          content: '""',
          position: "absolute",
          top: 0,
          right: { xs: "-43px", sm: "-43px", md: "-20px" },
          width: 0,
          height: 0,
          borderTop: {
            xs: "16px solid transparent",
            sm: "16pxsolid transparent",
            md: "20.5px solid transparent",
          },
          borderBottom: {
            xs: "19px solid transparent",
            sm: "19px solid transparent",
            md: "20.5px solid transparent",
          },
          borderLeft: {
            xs: "44px solid #27B1BB",
            sm: "44px solid #27B1BB",
            md: "20px solid #27B1BB",
          },
        }}
      />
      {/* )} */}
    </Box>
  );
}

export default BreadCrumb;
